<template>
    <div class="card position-relative w-100" style="height: calc(100% - 1.5rem)">
      <img
        class="position-absolute resize"
        style="width: 25px; height: 35px; left: -18px; display: none"
        src="../../assets/images/left-right.svg"
        alt=""
      />
      <div class="card-header align-items-center d-flex">
        <h4 class="card-title mb-0 flex-grow-1">
          {{ this.$t("page.atlas-analysis.SelectedData") }}
        </h4>
      </div>
      <div class="card-body h-100">
        <div class="row p-2 mb-2">
          <div class="col-3">
            <div>{{ this.$t("page.atlas-analysis.time granularity") }}</div>
            <select
              class="form-select mt-2"
              v-model="prePageNum"
              @change="timeChange"
            >
              <option
                v-for="t in timeGranularity"
                :key="t.value"
                :value="t.value"
              >
                {{ t.label }}
              </option>
            </select>
          </div>
  
          <div class="col-9">
            <div>{{ this.$t("base.select-date") }}</div>
            <div class="input-group flex-nowrap mt-2">
              <el-date-picker
                v-model="daterange"
                type="datetimerange"
                :shortcuts="shortcuts"
                :range-separator="this.$t('page.atlas-analysis.reach')"
                :start-placeholder="this.$t('serviceCompany.begin_date')"
                :end-placeholder="this.$t('serviceCompany.end_date')"
                @blur="dateChange($event)"
                :clearable="false"
                :disabled-date="disabledDate"
                @calendar-Change="calendarChange" 
              />
            </div>
          </div>
  
          <div
            style="border-bottom: 1px solid #e9ebec"
            class="w-100 p-2 m-2"
          ></div>
        </div>
        <div
          style="
            height: calc(100% - 160px);
            width: 100%;
            overflow: auto;
            min-width: 515px;
          "
          :class="
            !draglist.length && 'd-flex align-items-center justify-content-center'
          "
        >
          <template v-if="draglist.length">
            <div
              class="d-flex m-0 mb-3"
              v-for="(a, index) in draglist"
              :key="a"
              style="min-width: 490px"
            >
              <div
                class="d-flex justify-content-between"
                style="min-width: 260px"
              >
                <div
                  :style="{
                    background: [
                      'rgba(102, 145, 231, 0.101961)',
                      'rgba(134, 92, 226, 0.101961)',
                      'rgba(80, 195, 230, 0.101961)',
                      'rgba(236, 156, 98, 0.101961)',
                      'rgba(60, 146, 173, 0.101961)',
                      'rgba(50, 246, 173, 0.101961)',
                    ][index],
                    borderRadius:'2px 4px 4px 2px',
                    borderLeft: [
                      '3px rgba(102, 145, 231) solid',
                      '3px rgba(134, 92, 226) solid',
                      '3px rgba(80, 195, 230) solid',
                      '3px rgba(236, 156, 98) solid',
                      '3px rgba(60, 146, 173) solid',
                      '3px rgba(50, 246, 173) solid',
                    ][index],
                    lineHeight: ' 20px',
                    paddingLeft: '10px',
                    paddingRight: '5px',
                    marginRight: ' 10px',
                    fontSize: '12px',
                    height: '20px',
                  }"
                >
                  {{ a.name }}
                </div>
                <i
                  @click="delDragData(a)"
                  class="ri-delete-bin-line"
                  style="
                    font-size: 20px;
                    line-height: 20px;
                    height: 20px;
                    cursor: pointer;
                  "
                ></i>
              </div>
              <div class="me-3 ms-3">
                <div
                  class="form-switch form-switch-right form-switch-md line-h d-inline-flex accordion-button-class"
                >
                  <label for="thumbnails-image" class="form-label text-muted">{{
                    this.$t("page.atlas-analysis.StaticThreshold")
                  }}</label>
                  <input
                    v-model="a.enabled"
                    @change="staticChange(a)"
                    class="form-check-input code-switcher"
                    type="checkbox"
                    id="thumbnails-image"
                  />
                </div>
              </div>
              <div>
                <div
                  class="form-switch form-switch-right form-switch-md d-inline-flex accordion-button-class"
                >
                  <label for="thumbnails-image" class="form-label text-muted">{{
                    this.$t("page.atlas-analysis.DynamicThreshold")
                  }}</label>
                  <input
                    v-model="a.dynamic_threshold_enabled"
                    @change="dyThresholdChange(a, index)"
                    class="form-check-input code-switcher"
                    type="checkbox"
                    id="thumbnails-image"
                  />
                </div>
              </div>
            </div>
          </template>
          <div style="color: #212529; font-size: 16px; text-align: center" v-else>
            {{
              this.$t(
                "page.atlas-analysis.PleaseFirstDragTheMeasuringPointOnTheLeftSideToPlaceItOnTheChart"
              )
            }}
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 50%;
            bottom: 10px;
            transform: translateX(-50%);
          "
        >
          <button
            type="button"
            class="btn btn-primary"
            @click="goHistory()"
            :disabled="!draglist.length"
          >
            <i class="mdi fs-16 mdi-chart-areaspline text-white me-1"></i
            >{{ this.$t("page.health-monitoring.viewing_historical_data") }}
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ElDatePicker } from "element-plus";
  import "element-plus/theme-chalk/el-date-picker.css";
  import "element-plus/es/components/date-picker/style/css";
  import * as echarts from "echarts";
  import moment from "moment";
  import i18n from "@/i18n";
  export default {
    emits: [
      "delDragData",
      "staticSwitch",
      "dyThresholdSwitch",
      "getValueHealthData",
      "update:daterange",
      "update:prePageNum",
    ],
    props: {
      draglist: {
        type: Array,
        default: () => {
          return [];
        },
      },
      date: String,
    },
    setup() {},
    data() {
      return {
        prePageNum: "1s",
        timeGranularitylist: {
          lt1h: [
            {
              label: `1${i18n.global.t("page.atlas-analysis.sed")}`,
              value: "1s",
            },
          ],
          gt1hlt6h: [
            { label: `5${this.$t("page.atlas-analysis.sed")}`, value: "5s" },
            { label: `10${this.$t("page.atlas-analysis.sed")}`, value: "10s" },
            { label: `30${this.$t("page.atlas-analysis.sed")}`, value: "30s" },
            { label: `1${this.$t("page.atlas-analysis.min")}`, value: "1m" },
            { label: `5${this.$t("page.atlas-analysis.min")}`, value: "5m" },
            { label: `15${this.$t("page.atlas-analysis.min")}`, value: "15m" },
            { label: `30${this.$t("page.atlas-analysis.min")}`, value: "30m" },
            { label: `1${this.$t("page.atlas-analysis.hour")}`, value: "1h" },
          ],
          gt6hlt1d: [
            { label: `30${this.$t("page.atlas-analysis.sed")}`, value: "30s" },
            { label: `1${this.$t("page.atlas-analysis.min")}`, value: "1m" },
            { label: `5${this.$t("page.atlas-analysis.min")}`, value: "5m" },
            { label: `15${this.$t("page.atlas-analysis.min")}`, value: "15m" },
            { label: `30${this.$t("page.atlas-analysis.min")}`, value: "30m" },
            { label: `1${this.$t("page.atlas-analysis.hour")}`, value: "1h" },
            // { label: `6${this.$t("page.atlas-analysis.hour")}`, value: "6h" },
          ],
          gt1dlt15d: [
            { label: `5${this.$t("page.atlas-analysis.min")}`, value: "5m" },
            { label: `15${this.$t("page.atlas-analysis.min")}`, value: "15m" },
            { label: `30${this.$t("page.atlas-analysis.min")}`, value: "30m" },
            { label: `1${this.$t("page.atlas-analysis.hour")}`, value: "1h" },
            // { label: `6${this.$t("page.atlas-analysis.hour")}`, value: "6h" },
            // { label: `1${this.$t("page.atlas-analysis.day")}`, value: "1d" },
            // { label: `7${this.$t("page.atlas-analysis.day")}`, value: "7d" },
          ],
          gt15dlt30d: [
            { label: `15${this.$t("page.atlas-analysis.min")}`, value: "15m" },
            { label: `30${this.$t("page.atlas-analysis.min")}`, value: "30m" },
            { label: `1${this.$t("page.atlas-analysis.hour")}`, value: "1h" },
            // { label: `6${this.$t("page.atlas-analysis.hour")}`, value: "6h" },
            // { label: `1${this.$t("page.atlas-analysis.day")}`, value: "1d" },
            // { label: `7${this.$t("page.atlas-analysis.day")}`, value: "7d" },
          ],
          gt30: [
            { label: `1${this.$t("page.atlas-analysis.day")}`, value: "1d" },
            { label: `7${this.$t("page.atlas-analysis.day")}`, value: "7d" },
            { label: `30${this.$t("page.atlas-analysis.day")}`, value: "30d" },
          ],
        },
        timeGranularity: [
          { label: `1${this.$t("page.atlas-analysis.sed")}`, value: "1s" },
        ],
        daterange: [
          moment().subtract(1, "h").format("YYYY-MM-DD HH:mm:ss"),
          moment().format("YYYY-MM-DD HH:mm:ss"),
        ],
        shortcuts: [
          {
            text: this.$t("page.atlas-analysis.Last7Days"),
            value: () => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.$t("page.atlas-analysis.ThisMonth"),
            value: () => {
              const end = moment().endOf("month").valueOf();
              const start = moment().startOf("month").valueOf();
              return [start, end];
            },
          },
          {
            text: this.$t("page.atlas-analysis.LastMonth"),
            value: () => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
        ],
        choiceDate:null,
      };
    },
    components: {
      ElDatePicker,
    },
    watch: {
      daterange(newValue) {
        console.log(newValue);
        this.$emit("update:daterange", newValue);
        if (newValue && newValue.length) {
          let start = newValue[0];
          let end = newValue[1];
          let diff = moment(end).diff(moment(start), "minutes");
          console.log(
            moment(end).format("YYYY-MM-DD HH:mm:ss"),
            moment(start).format("YYYY-MM-DD HH:mm:ss"),
            diff
          );
  
          if (diff <= 60) {
            console.log(1);
            this.timeGranularity = this.timeGranularitylist["lt1h"];
            this.prePageNum = "1s";
          } else if (diff > 60 && diff <= 360) {
            console.log(2);
            this.timeGranularity = this.timeGranularitylist["gt1hlt6h"];
            this.prePageNum = "5s";
          } else if (diff > 360 && diff <= 24 * 60) {
            console.log(3);
            this.timeGranularity = this.timeGranularitylist["gt6hlt1d"];
            this.prePageNum = "30s";
          } else if (diff > 24 * 60 && diff <= 24 * 15 * 60) {
            console.log(4);
            this.timeGranularity = this.timeGranularitylist["gt1dlt15d"];
            this.prePageNum = "5m";
          } else if (diff > 24 * 15 * 60 && diff <= 24 * 30 * 60) {
            console.log(5);
            this.timeGranularity = this.timeGranularitylist["gt15dlt30d"];
            this.prePageNum = "15m";
          } else if (diff > 24 * 30 * 60) {
            console.log(6);
            this.timeGranularity = this.timeGranularitylist["gt30"];
            this.prePageNum = "1d";
          }
        }
        console.log(this.timeGranularity, this.prePageNum);
      },
      prePageNum(newVal) {
        this.$emit("update:prePageNum", newVal);
      },
    },
    mounted() {
      this.dragControllerDiv();
      var startTime = this.$route.query.startTime;
      var endTime = this.$route.query.endTime;
      if (startTime && endTime) {
        this.daterange[0] = moment(Number(startTime)).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.daterange[1] = moment(Number(endTime)).format("YYYY-MM-DD HH:mm:ss");
        this.$emit("update:daterange", [
          moment(Number(startTime)).format("YYYY-MM-DD HH:mm:ss"),
          moment(Number(endTime)).format("YYYY-MM-DD HH:mm:ss"),
        ]);
      }
      /*  else {
        if (this.daterange && this.daterange.includes("至")) {
          let time = this.daterange.split("至");
          this.start_date_start_time = +new Date(time[0]);
          this.start_date_end_time = +new Date(time[1]);
          let currentDateTime = moment(new Date());
          let timerange = {};
          if (this.start_date_start_time > currentDateTime) {
            timerange.end = moment(this.start_date_end_time).diff(
              moment(currentDateTime),
              "minute"
            );
          } else if (
            this.start_date_start_time <= currentDateTime &&
            this.start_date_end_time >= currentDateTime
          ) {
            timerange.start = moment(currentDateTime).diff(
              moment(this.start_date_start_time),
              "minute"
            );
            timerange.end = moment(this.start_date_end_time).diff(
              moment(currentDateTime),
              "minute"
            );
          } else {
            timerange.start = moment(currentDateTime).diff(
              moment(this.start_date_start_time),
              "minute"
            );
          }
        }
      } */
    },
    methods: {
      /* 控制选择时间在一个月以内*/
      disabledDate(time){
        if (this.choiceDate) {
        // 一个月的时间戳
        const one = 30 * 24 * 3600 * 1000;
        // 当前日期 - one = 一个月之前
        const minTime = this.choiceDate - one;
        // 当前日期 + one = 一个月之后
        const maxTime = this.choiceDate + one;
        return (
          time.getTime() < minTime ||
          time.getTime() > maxTime
          // 限制不能选择今天及以后
          // || time.getTime() + 1 * 24 * 3600 * 1000 > Date.now()
        );
      } else {
        // 如果没有选择日期，就要限制不能选择今天及以后
        // return time.getTime() + 1 * 24 * 3600 * 1000 > Date.now();
      }
      },
      calendarChange(date){
        const minDate = date[0]
        const maxDate = date[1]
        // 把选择的第一个日期赋值给一个变量。
        this.choiceDate = minDate.getTime();
        // 如何你选择了两个日期了，就把那个变量置空
        if (maxDate) this.choiceDate = null;
      },
      dateChange(date) {
          if(moment(this.daterange[1])._i.$d&&moment(this.daterange[0])._i.$d){
              let diff = moment(moment(this.daterange[1])._i.$d).diff(
                moment(this.daterange[0])._i.$d,
                "minutes"
              );
              console.log(
                moment(moment(this.daterange[0])._i.$d),
                moment(moment(this.daterange[1])._i.$d),
                diff
              );
              this.daterange[0] = moment(moment(this.daterange[0])._i.$d).format('YYYY-MM-DD HH:mm:ss');
              this.daterange[1] = moment(moment(this.daterange[1])._i.$d).format('YYYY-MM-DD HH:mm:ss');
              if (diff <= 60) {
                console.log(1);
                this.timeGranularity = this.timeGranularitylist["lt1h"];
                this.prePageNum = "1s";
              } else if (diff > 60 && diff <= 360) {
                console.log(2);
                this.timeGranularity = this.timeGranularitylist["gt1hlt6h"];
                this.prePageNum = "5s";
              } else if (diff > 360 && diff <= 24 * 60) {
                console.log(3);
                this.timeGranularity = this.timeGranularitylist["gt6hlt1d"];
                this.prePageNum = "30s";
              } else if (diff > 24 * 60 && diff <= 24 * 15 * 60) {
                console.log(4);
                this.timeGranularity = this.timeGranularitylist["gt1dlt15d"];
                this.prePageNum = "5m";
              } else if (diff > 24 * 15 * 60 && diff <= 24 * 30 * 60) {
                console.log(5);
                this.timeGranularity = this.timeGranularitylist["gt15dlt30d"];
                this.prePageNum = "15m";
              } else if (diff > 24 * 30 * 60) {
                console.log(6);
                this.timeGranularity = this.timeGranularitylist["gt30"];
                this.prePageNum = "1d";
              }
          }
      },
      moment,
      goHistory() {
        if (this.draglist.length) {
          let start = this.daterange[0];
          let end = this.daterange[1];
          localStorage.setItem("daterange", JSON.stringify(this.daterange));
          this.$emit("getValueHealthData", {
            prePageNum: this.prePageNum,
            end:
              moment().diff(moment(end), "minute") >= 0
                ? moment().diff(moment(end), "minute") + "m"
                : "0m",
            start: moment().diff(moment(start), "minute") + "m",
          });
        }
      },
      timeChange(ev) {
        this.prePageNum = ev.target.value;
      },
      staticChange(a) {
        this.$emit("staticSwitch", a);
      },
      dyThresholdChange(a, index) {
        a["index"] = index;
        this.$emit("dyThresholdSwitch", a);
      },
      delDragData(a) {
        this.$emit("delDragData", a);
      },
      /* imgDraggable() {
        let box = document.getElementById("right-box");
        let box1 = document.getElementById("left-box");
      }, */
      dragControllerDiv() {
        var resize = document.getElementsByClassName("resize");
        var left = document.getElementsByClassName("left-box");
        var right = document.getElementsByClassName("right-box");
        var box = document.getElementsByClassName("resize-box");
        for (let i = 0; i < resize.length; i++) {
          // 鼠标按下事件
          resize[i].onmousedown = (e) => {
            //颜色改变提醒
            resize[i].style.background = "#d6d6d6";
            var startX = e.clientX;
            resize[i].left = resize[i].offsetLeft;
            // 鼠标拖动事件
            document.onmousemove = (e) => {
              var endX = e.clientX;
              var moveLen = resize[i].left + (endX - startX) + 250; // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
              var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
  
              if (moveLen < 300) moveLen = 300; // 左边区域的最小宽度
              if (moveLen > maxT - 200) moveLen = maxT - 200; //右边区域最小宽度为200px
  
              resize[i].style.left = moveLen; // 设置左侧区域的宽度
  
              for (let j = 0; j < left.length; j++) {
                left[j].style.width = `calc(100% - ${moveLen} + "px")`;
                right[j].style.width = box[i].clientWidth - moveLen - 10 + "px";
              }
              const myChart = echarts.getInstanceByDom(
                document.getElementById("health_monitor")
              );
              this.$nextTick(() => {
                myChart.resize();
              });
            };
            // 鼠标松开事件
            document.onmouseup = function () {
              //颜色恢复
              resize[i].style.background = "none";
              document.onmousemove = null;
              document.onmouseup = null;
              resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
            };
            resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
            return false;
          };
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  :deep(.el-range-editor.el-input__inner) {
    height: 36px !important;
  }
  </style>
  